import AbstractAction from "../AbstractAction";

export default class AddSpeciesToElementAction extends AbstractAction {
    constructor(provider, element, species) {
        super(provider);

        this.elementCollection = Array.isArray(element) ? element : [element];
        this.species = species;
        this.infoTab = this.getTab('info');
    }

    finish() {
        let hasSpeciesAdded = false;
        this.elementCollection.forEach((element) => {
            hasSpeciesAdded = element.addSpecies(this.species) || hasSpeciesAdded;
            this.infoTab.reload(element);
        });
        if (hasSpeciesAdded) {
            this.actions.finish();
        } else {
            this.actions.discard();
        }

        super.finish();
    }

    undo() {
        this.elementCollection
            .forEach((el) => {
                el.removeSpecies(this.species)
                this.infoTab.reload(el);
            });
    }

    redo() {
        this.elementCollection
            .forEach((el) => {
                el.addSpecies(this.species, true)
                this.infoTab.reload(el);
            });
    }
}
